import {inject, Injectable} from '@angular/core';
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {GetSelectDataParams, SelectData} from "../../../../../../../core/types/records-table.types";
import {articleTypeLazy, priceLevelGapTypeLazy} from "../configs/price-level-gap-type-lazy";
import {CreatePriceLevelDataParams} from "../types/create-price-level-configs.types";
import {CreatePriceLevelConfigsApiService} from "./create-price-level-configs-api.service";

@Injectable({
  providedIn: 'root'
})
export class CreatePriceLevelConfigsService {
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private createPriceLevelConfigsApiService: CreatePriceLevelConfigsApiService = inject(CreatePriceLevelConfigsApiService);

  public fetchArticleSelectData(): Promise<Array<SelectData>> {
    const params: GetSelectDataParams = {
      propertyLazySelect: articleTypeLazy
    };

    return new Promise<Array<SelectData>>((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public fetchGapTypeSelectData(): Promise<Array<SelectData>> {
    const params: GetSelectDataParams = {
      propertyLazySelect: priceLevelGapTypeLazy
    };

    return new Promise<Array<SelectData>>((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createPriceLevelConfigsData(params: CreatePriceLevelDataParams): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.createPriceLevelConfigsApiService.createPriceLevelConfigsData(params).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      })
    });
  }
}
